/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../Navbar";
import Header from "../Header";
import baseUrl from "../BaseUrl";
import Loader from "../Loader";
import { useNavigate, Link } from 'react-router-dom';
import Pagination from "react-js-pagination";
 
const VPNSettings = () => {
    const [userName, setUserName] = useState('');
    const [token, setToken] = useState('');
    const [expire, setExpire] = useState('');
    const [apiError, setApiError] = useState(null); // Renamed for clarity from general 'error'
    const [role, setRole] = useState('');
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
   
    const [newVpnIpRange, setNewVpnIpRange] = useState({ cidr_value: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [isAdd, setIsAdd] = useState(false);
    const [vpnIpRanges, setVpnIpRanges] = useState([]);
    const [editIndex, setEditIndex] = useState(null);
    const [access, setAccess] = useState([]);
    const [popupOpen, setPopupOpen] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [formErrors, setFormErrors] = useState({}); // Renamed for clarity from 'errors'
    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
    }, []);
    useEffect(() => {
        if (token) { // Ensure token is available before fetching
            getVpnIpRangeList(page);
            getUserAccess(); // Moved here to ensure token is likely set
        }
    }, [page, token]);
    useEffect(() => {
        if(role >= 2){
            checkAccess();
        }
        
    }, [role]);
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setRole(decoded.role);
            setUserName(decoded.name);
            setExpire(decoded.exp);
        } catch (error) {
           
            if (error.response) {
                // setApiError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }

    const handlePageChange  = (pageNumber) => {
        setPage(pageNumber);
    }
   

    const getUserAccess = async () => {
        try {
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
           
            setAccess(response.data.results);
            // setIsLoading(false);
            
        } catch (error) {
           console.error("Error fetching user access:", error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setApiError("Unauthorized");
            //     navigate("/");  
            //     // window.location.reload();
            // }
        }
    }
   

    const checkAccess = async () => {
        navigate('/dashboard');
    }
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setUserName(decoded.name);
            setExpire(decoded.exp);
            setRole(decoded.role); // Also update role if it changes with token refresh
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    const getVpnIpRangeList = async (pageNumber) => {
        setPopupOpen(true);
        try {
            const response = await axiosJWT.get(`${baseUrl}/vpn-ip-range-settings?page=${pageNumber}&limit=${20}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setVpnIpRanges(response.data.data);
            setTotalItem(response.data.totalItem);
        } catch (err) {
            console.error("Error fetching VPN IP Ranges:", err);
            setApiError("Failed to load VPN IP Ranges.");
        } finally {
            setPopupOpen(false);
        }
    }

  
   
    const handleAddVpnIpRange = () => {
        setNewVpnIpRange({ cidr_value: '' });
        setIsEditing(false);
        setIsAdd(!isAdd);
        setEditIndex(null);
        setFormErrors({});
        setApiError(null);
    };

    const handleInputChange = (e) => {
        setNewVpnIpRange({ ...newVpnIpRange, [e.target.name]: e.target.value });
    };

    const validate = () => {
        const errors = {};
        const cidrRegex = /^([0-9]{1,3}\.){3}[0-9]{1,3}(\/([0-9]|[1-2][0-9]|3[0-2]))$/;

        if (!newVpnIpRange.cidr_value.trim()) {
          errors.cidr_value = 'CIDR Range is required';
        } else if (!cidrRegex.test(newVpnIpRange.cidr_value.trim())) {
          errors.cidr_value = 'Invalid CIDR format (e.g., 192.168.1.0/24)';
        }
        return errors;
      };

    const handleSave = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
          setFormErrors(validationErrors);
          return;
        }
        
        let payload;

        if (isEditing) {
            payload = { id: newVpnIpRange.id, cidr_value: newVpnIpRange.cidr_value.trim() };
        } else {
            payload = { cidr_value: newVpnIpRange.cidr_value.trim() };
          }

          try {
            setButtonDisabled(true);
            setPopupOpen(true);
            await axiosJWT.post(`${baseUrl}/vpn-ip-range-settings`, payload, {headers: {
                Authorization: `Bearer ${token}`
            }});
            
            // Success: Reset form, refresh list
            setIsAdd(false);
            setIsEditing(false);
            setEditIndex(null);
            setNewVpnIpRange({ cidr_value: '' });
            getVpnIpRangeList(page); // Refresh current page
            setApiError(null); // Clear previous API errors
        } catch (error) {
            console.error("Error saving VPN IP Range:", error);
            setApiError(error.response?.data?.msg || error.response?.data?.message || "Failed to save VPN IP Range. Please try again.");
        } finally {
            setButtonDisabled(false);
            setPopupOpen(false);
        }
        setFormErrors({}); // Clear form validation errors after attempt
    };

    const handleEdit = (index) => {
        const vpnRange = vpnIpRanges[index];
        setNewVpnIpRange({...vpnRange}); // Ensure all fields like id are copied
        setIsEditing(true);
        setEditIndex(index);
        setIsAdd(false);
        setFormErrors({});
        setApiError(null);
    };

    const disableVpnIpRange = async (id) => {
        const shouldDelete = window.confirm("Are you sure you want to disable this VPN IP Range?");
        if (shouldDelete) {
            try {
                setPopupOpen(true);
                await axiosJWT.delete(`${baseUrl}/vpn-ip-range-settings/${id}`,{headers: {
                    Authorization: `Bearer ${token}`
                }});
                getVpnIpRangeList(page); // Refresh list
                setApiError(null);
            } catch (error) {
                console.error("Error disabling VPN IP Range:", error);
                setApiError(error.response?.data?.msg || error.response?.data?.message || "Failed to disable VPN IP Range.");
            } finally {
                setPopupOpen(false);
            }
        }
    }

    return (
        <div className="panelbox">
           <Navbar token={token} access={access}/>
            <div className="right-panel">
            <Header name={userName} />
            {popupOpen && (
                     <Loader /> 
                ) }
            <div className="content-page admin-attendance-page">
                <div className="row">
                    {apiError && <div className="col-12"><p className="error error-message" style={{color: 'red'}}>{apiError}</p></div>}
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="left-title">
                            <h1>BBD User Exempt MFA IP List</h1>
                        </div>
                    </div>
                    <div className="col-6 inventory-btn">
                        <div className="addnew-button">
                            <Link to="/settings"><span>&larr;</span> Back</Link>
                            <a className="newrow" onClick={handleAddVpnIpRange} style={{ cursor: 'pointer' }}> Add VPN IP Range</a>
                        </div>
                    </div>
                </div>
                <div className="fullrow">
                    <div className="row admin-staff-list-toppart">
                        <div className="col-md-8">
                            <div className="boxinput">
                            
                            
                            </div>
                        </div>
                        
                    </div>
                    
                    <div className="row">
                        <div className="col-12">
                        { isAdd && 
                            <div className="common-white-shadow-background setting-section">
                                <div className="row">
                                    {/* Removed range_index input field */}
                                    <div className="col-sm-6" > 
                                        <input
                                            type="text"
                                            name="cidr_value"
                                            placeholder="CIDR Range (e.g., 192.168.1.0/24)"
                                            value={newVpnIpRange.cidr_value}
                                            onChange={handleInputChange}
                                        />
                                        {formErrors.cidr_value && <div className="error error-message">{formErrors.cidr_value}</div>}
                                    </div>
                                    <div className="col-sm-3 boxinput company-search" >
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a href="#" className={buttonDisabled ? 'disabled-link search-btn clear-btn' : 'search-btn clear-btn'} onClick={handleSave} >Save</a>
                                    </div>
                                </div>
                            </div>}
            
        
                            <div className="fullwidth-table track-table-body staff-listing-admin-table-body">
                                <table>
                                    <thead>
                                    <tr>
                                        {/* Removed Index header */}
                                        <th>CIDR Range</th>
                                        <th>Active</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {vpnIpRanges.map((item, index) => (
                                        <tr key={item.id}>
                                            
                                            {/* Removed Index data cell */}
                                            <td>
                                                {editIndex === index ? 
                                                    <>
                                                    <input
                                                        type="text"
                                                        name="cidr_value"
                                                        placeholder="CIDR Range"
                                                        value={newVpnIpRange.cidr_value}
                                                        onChange={handleInputChange}
                                                    />
                                                    {formErrors.cidr_value && <div className="error error-message">{formErrors.cidr_value}</div>}</> : 
                                                    item.cidr_value
                                                }
                                            </td>
                                            
                                            <td>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            {editIndex === index && <a href="#" className={buttonDisabled ? 'disabled-link' : ''}  onClick={handleSave} ><img src={`${process.env.PUBLIC_URL}/images/success.png`} alt="Save" title="Save Changes" /></a>}
                                                {item.status === 1 && editIndex !== index && <a onClick={() => handleEdit(index)}><img src={`${process.env.PUBLIC_URL}/images/bx-edit.png`} alt="Edit" title="Use this option to edit VPN IP Range" /></a>}
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <a onClick={() => disableVpnIpRange(item.id)}><img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`} alt="Disable" title="Use this option to disable VPN IP Range" /></a>
                                            </td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                                {totalItem > 20 && (<Pagination
                                  activePage={page}
                                  itemsCountPerPage={20}
                                  totalItemsCount={totalItem}
                                  pageRangeDisplayed={5}
                                  onChange={handlePageChange.bind(this)}
                                />)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>               
            </div>
        </div>
    )
}
 
export default VPNSettings